import { render, staticRenderFns } from "./ContentProducers.vue?vue&type=template&id=a6216852&scoped=true&"
import script from "./ContentProducers.vue?vue&type=script&lang=js&"
export * from "./ContentProducers.vue?vue&type=script&lang=js&"
import style0 from "./ContentProducers.vue?vue&type=style&index=0&id=a6216852&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6216852",
  null
  
)

export default component.exports